export default __webpack_public_path__ + "920ceb6a3d0012a32fd80ecf60ea9972.gif";